import React, { useEffect, useState } from 'react';
import { Button, Typography, IconButton, TextField } from '@mui/material';
import './style.css';
import { AiOutlineMinus, AiOutlinePlus } from 'react-icons/ai';
import { useNavigate, useParams } from 'react-router-dom';
import useProduct from '../../../Hook/useProduct';
import { MdCurrencyRupee } from "react-icons/md";


const imageUrl = process.env.REACT_APP_BASH_IMG_URL;

function ProductDetails() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [quantity, setQuantity] = useState(1); // Default quantity
    const { loading, getSingleProduct } = useProduct();
    const [product, setProduct] = useState(null); // Initialize as null
    const [mainImage, setMainImage] = useState(''); // Default main image state

    // Function to handle the increment/decrement of quantity
    const handleQuantityChange = (action) => {
        if (action === 'increase') {
            setQuantity(prev => prev + 1);
        } else if (action === 'decrease' && quantity > 1) {
            setQuantity(prev => prev - 1);
        }
    };

    useEffect(() => {
        const fetchProduct = async () => {
            const result = await getSingleProduct(id);
            setProduct(result);

            // Set the main image after the product data is fetched and has images
            if (result?.images?.length > 0) {
                setMainImage(result?.images[0]?.image); // Set first image as the main image
            }
        };

        fetchProduct();
    }, [id]);

    const handleCheckout = () => {

        navigate("/checkout", {
            state: {
                product,
                quantity,
                total: product?.price * quantity
            }
        });

    };

    return (
        <div className='productDetailsContainer'>
            {/* Image gallery */}
            <div className='imageGallery'>
                <img
                    src={mainImage ? mainImage : 'fallback_image_url'}
                    alt="product"
                    className='mainProductImage'
                />
                <div className='thumbnailContainer'>
                    {product?.images?.map((item, ind) => (
                        <img
                            key={ind}
                            src={item?.image}
                            alt="thumbnail"
                            onClick={() => setMainImage(item?.image)} // Set clicked image as main image
                            className='thumbnailImage'
                        />
                    ))}
                </div>
            </div>

            {/* Product details */}
            <div className='productInfo'>
                <Typography variant="h4" sx={{ my: 1 }}>{product?.name}</Typography>
                <Typography variant="body1" className="productDescription" sx={{ my: 1 }}>{product?.description}</Typography>
                <Typography variant="h5" className='productPrice' sx={{ my: 1 }}>Price: <MdCurrencyRupee /> {product?.price}</Typography>

                {/* Quantity selector */}
                <div className='quantitySelector'>
                    <IconButton onClick={() => handleQuantityChange('decrease')}><AiOutlineMinus /></IconButton>
                    <TextField value={quantity} variant="outlined" size="small" className='quantityInput' inputProps={{ style: { textAlign: 'center' } }} />
                    <IconButton onClick={() => handleQuantityChange('increase')}><AiOutlinePlus /></IconButton>
                </div>

                {/* Total amount */}
                <Typography variant="h6" className='totalAmount' sx={{ my: 1 }}>Total: <MdCurrencyRupee /> {product?.price * quantity}</Typography>

                {/* Add to cart button */}
                {/* <Button variant="contained" color="primary" className='addToCartButton'>Add to Cart</Button> */}
                <Button variant="contained" color="success" size="large" fullWidth onClick={handleCheckout}>Proceed to Checkout</Button>
            </div>
        </div>
    );
}

export default ProductDetails;
